export default __webpack_public_path__ + "static/media/Work.81ddaf98.svg";